import { useDisclosure } from "@chakra-ui/react";

import { Button } from "../shared/Button";
import ProductCard from "./product-card";
import MedicalRequestModal from "./medical-request-modal";
import { Product } from "../../api/products";
import { formatter, formatterNoDecimal } from "../shared/util";
import { Analytics, Actions, Features } from "../shared/analytics";

export default function MedicalAPIProduct({
  product,
  isActive,
  onSubscribe,
  isSubscribing,
  isSandbox,
}: {
  product: Product;
  isActive: boolean;
  onSubscribe: () => void;
  isSubscribing: boolean;
  isSandbox: boolean;
}) {
  const { isOpen, onOpen, onClose } = useDisclosure({});

  const flatRate = product.flatRate ? formatterNoDecimal.format(product.flatRate / 100) : null;
  const pricePerUser = product.pricePerUser ? formatter.format(product.pricePerUser / 100) : null;

  const onFormOpen = () => {
    onOpen();
    Analytics.emit(Actions.open, Features.form, { type: Features.medicalRequest });
  };

  return (
    <>
      <ProductCard
        name={product.name}
        pricingDetailsUrl="https://www.metriport.com/medical#pricing"
        isActive={isActive}
        flatRate={flatRate}
        nOfUsers={product.upToAmount}
        pricePerUser={pricePerUser}
        footer={
          !isSandbox && (
            <Button
              size={"lg"}
              isLoading={isSubscribing}
              onClick={() => {
                if (isActive) {
                  onSubscribe();
                } else {
                  onFormOpen();
                }
              }}
            >
              {isActive ? "Manage Subscription" : "Get Started"}
            </Button>
          )
        }
      />
      <MedicalRequestModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
